import { LoadablePaint } from '@confluence/loadable';

export const LazyUserAccessPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-UserAccessPage" */ '../src/UserAccess/UserAccessPage.tsx'
			)
		).UserAccessPage,
});
